import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import ButtonBase from "@mui/material/ButtonBase";

import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";

export default function LogoSection({ reverse, isIcon, sx, to }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || "/radar"} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.any,
  to: PropTypes.any,
};
